import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { XUpdatedKeys, YUpdatedKeys } from '../reducers/ruler2d.reducer';

export const stop = action('[Ruler2d] stop');

export const setBoundary = action(
  '[Ruler2d] setBoundary',
  props<{
    xBoundary?: XUpdatedKeys;
    yBoundary?: YUpdatedKeys;
    timestamp?: number;
    voltage?: number;
  }>(),
);

export const setTimestamp = action(
  '[Ruler2d] setTimestamp',
  props<{ timestamp: number } & SkipHistory>(),
);

export const setVoltage = action(
  '[Ruler2d] setVoltage',
  props<{ voltage: number } & SkipHistory>(),
);

export const setMoving = action(
  '[Ruler2d] setMoving',
  props<{ timestamp: number; voltage: number }>(),
);
